import { Attrs, MinzeElement } from 'minze'

export interface LvcHandDrawnButton1 {
  inject: string
}

export class LvcHandDrawnButton1 extends MinzeElement {
  attrs: Attrs = [['inject', null]]
  parsedAttrs: any = {}
  static observedAttributes = ['inject']

  onAttributeChange(
    name?: string,
    oldValue?: string | null,
    newValue?: string | null
  ): Promise<void> | void {
    if (name === 'inject' && newValue) {
      this.parsedAttrs = JSON.parse(newValue)
      this.rerender()
    }
  }

  html = () => `
    <!-- Corners -->
    <svg viewBox="0 0 84 84" part="border-top-left">
      <path d="M83.333 83.333H13.33l1.743-8.179c1.269-5.771 2.514-11.434 3.65-17.106C24.46 29.409 48.37 5.007 78.443 5.064l4.89-.003v78.272Z" class="background-from"/>
      <path d="M83.333.895v8.333l-4.898.003c-28.083-.054-50.27 22.891-55.626 49.635-1.142 5.697-2.392 11.386-3.666 17.182l-1.554 7.285H9.071l1.933-9.074c1.263-5.745 2.502-11.383 3.633-17.029C20.754 26.695 46.387.837 78.451.897l4.882-.002Z" class="border"/>
    </svg>
    <svg viewBox="0 0 84 84" part="border-top-right">
      <path d="m0 4.843 10.837-.004c33.309.054 58.3 29.776 56.23 62.529l-.589 15.965H0V4.843Z" class="background-to"/>
      <path d="M0 .676 10.844.672C46.557.73 73.445 32.513 71.225 67.63l-.58 15.703h-8.334l.597-16.228c1.922-30.389-21.173-58.05-52.077-58.1L0 9.009V.676Z" class="border"/>
    </svg>
    <svg viewBox="0 0 84 84" part="border-bottom-left">
      <path d="M83.333 73.645c-31.739-2.436-55.197-32.213-60.836-62.609L20.086 0h63.247v73.645Z" class="background-from"/>
      <path d="M3537.5 77.9c-292.368.971-747.973 1.551-1158.91 2.074-223.779.285-434.311.553-598.027.853-462.854.848-1305.37-.596-1693.22-2.764l-4.009-.248v-8.34l4.055.255c387.837 2.168 1230.32 3.611 1693.16 2.763 163.717-.299 374.251-.568 598.031-.852 410.933-.523 866.53-1.103 1158.92-2.075V77.9ZM15.823 0l-3.907-17.88c-1.663-7.083-3.359-14.304-4.953-21.805C3.096-57.886 0-77.075 0-97.813-.001-129.462 4.373-153.339 9.071-175h8.518c-4.727 21.638-9.256 45.411-9.256 77.187.001 20.121 3.029 38.736 6.782 56.396 1.581 7.441 3.264 14.605 4.914 21.632L24.349 0h-8.526ZM24.349 0l2.244 10.276c5.294 28.531 27.015 56.737 56.74 59.199v8.34C49.583 75.402 24.386 44.059 18.4 11.796L15.823 0h8.526Z" class="border"/>
    </svg>
    <svg viewBox="0 0 84 84" part="border-bottom-right">
      <path d="M0-175h66.478c-.82 16.142-.723 31.216.068 44.111 1.054 17.291 3.325 30.022 6.416 36.342 2.13 4.356 3.5 12.077 4.438 21.197.958 9.348 1.508 20.845 1.696 33.233L78.502 0H0v-175ZM0 73.733c-292.38.971-747.981 1.551-1158.92 2.074-223.779.285-434.312.553-598.029.853-462.846.848-1305.35-.596-1693.19-2.763l-4.032-.252V0H-.001v73.733ZM78.502 0l-2.423 35.882c-2.358 23.168-22.037 37.701-44.55 37.779L0 73.733V0h78.502Z" class="background-to"/>
      <path d="m82.677 0-2.453 36.305c-2.583 25.377-24.02 41.438-48.681 41.522L0 77.9v-8.334l31.515-.072c20.365-.07 38.286-13.076 40.419-34.034L74.328 0h8.349Z" class="border"/>
    </svg>

    <!-- Sides -->
    <div part="border-top">
      <svg viewBox="0 0 3455 84" preserveAspectRatio="none">
        <defs>
          <linearGradient id="gradient">
            <stop offset="0%" class="gradient-stop-1" />
            <stop offset="100%" class="gradient-stop-2" />
          </linearGradient>
        </defs>
        <path d="M0 258.333h-63.247l-4.114-18.832c-1.656-7.055-3.346-14.248-4.933-21.719-3.81-17.93-6.872-36.832-6.873-57.262 0-31.715 4.451-55.542 9.164-77.187H0v175ZM3454.17 83.333h66.478c-.821 16.143-.723 31.216.068 44.112 1.054 17.29 3.324 30.021 6.416 36.342 2.129 4.356 3.5 12.076 4.438 21.196.958 9.349 1.508 20.845 1.695 33.233l-.593 40.117h-78.502v-175ZM0 83.333V5.061l449.8-.271c57.317-.102 118.271-.21 184.3-.308 263.171-.387 606.979-.6 1122.86.466 468.187.968 800.899.512 1093.87.11l603.334-.215v78.49H-.006Z" style="fill:url(#gradient)"/>
        <path d="m3454.17 9.009-603.328.216c-292.975.401-625.691.857-1093.88-.11-515.877-1.066-859.68-.853-1122.85-.466-66.029.097-126.982.205-184.299.307L.006 9.228V.895L449.799.623C507.116.521 568.07.413 634.1.316c263.174-.388 606.987-.6 1122.88.466 468.181.967 800.89.511 1093.86.109l603.339-.215v8.333Z" class="border"/>
      </svg>
    </div>
    <div part="border-left">
      <svg viewBox="0 0 84 175" preserveAspectRatio="none">
        <path d="M83.333 175H20.086l-4.113-18.832c-1.657-7.055-3.346-14.248-4.934-21.719-3.81-17.93-6.872-36.833-6.872-57.262C4.166 45.472 8.617 21.645 13.33 0h70.003v175ZM83.333 0v-78.272l449.8-.272c57.317-.102 118.271-.21 184.3-.307 263.171-.387 606.979-.6 1122.86.466 468.187.967 800.9.511 1093.87.11l603.333-.216V0H83.326ZM3537.5 248.733c-292.38.971-747.981 1.551-1158.92 2.074-223.779.285-434.312.553-598.029.853-462.846.848-1305.35-.596-1693.19-2.763l-4.032-.252V175h3454.17v73.733Z" class="background-from"/>
        <path d="m15.823 175-3.907-17.88c-1.663-7.083-3.359-14.304-4.953-21.805C3.096 117.114 0 97.925 0 77.187-.001 45.538 4.373 21.661 9.071 0h8.518c-4.727 21.638-9.256 45.411-9.256 77.187.001 20.121 3.029 38.736 6.782 56.396 1.581 7.441 3.264 14.605 4.914 21.632L24.349 175h-8.526ZM24.349 175l2.244 10.276c5.294 28.531 27.015 56.737 56.74 59.199v8.34c-33.75-2.413-58.947-33.756-64.933-66.019L15.823 175h8.526ZM83.333-82.439v8.333l-4.898.003c-28.083-.053-50.27 22.892-55.626 49.636-1.142 5.697-2.392 11.386-3.666 17.182L17.589 0H9.071l1.933-9.074c1.263-5.745 2.502-11.383 3.633-17.03 6.117-30.535 31.75-56.393 63.814-56.332l4.882-.003Z" class="border"/>
      </svg>
    </div>
    <div part="border-right">
      <svg viewBox="0 0 84 175" preserveAspectRatio="none">
        <path d="M0 0h66.478c-.82 16.142-.723 31.216.068 44.111 1.054 17.291 3.325 30.022 6.416 36.342 2.13 4.356 3.5 12.077 4.438 21.197.958 9.348 1.508 20.845 1.696 33.233L78.502 175H0V0ZM0 248.733c-292.38.971-747.981 1.551-1158.92 2.074-223.779.285-434.312.553-598.029.853-462.846.848-1305.35-.596-1693.19-2.763l-4.032-.252V175H-.001v73.733ZM0-78.491l10.837-.004c33.309.054 58.3 29.776 56.23 62.529L66.478 0H0v-78.491ZM78.502 175l-2.423 35.883c-2.358 23.167-22.037 37.7-44.55 37.778L0 248.733V175h78.502Z" class="background-to"/>
        <path d="M74.328 175a689.7 689.7 0 0 0 .602-40.055c-.186-12.252-.727-23.623-1.675-32.87-.874-8.506-2.05-15.729-4.035-19.791-3.228-6.599-5.732-19.867-6.833-37.919-.795-12.974-.898-28.133-.076-44.365h8.334c-.819 16.05-.726 31.038.06 43.857v.001c1.008 16.529 3.045 28.722 6.001 34.765v.001c2.272 4.648 3.838 12.867 4.839 22.601.969 9.45 1.527 21.072 1.717 33.595.192 12.821-.004 26.661-.585 40.18h-8.349ZM82.677 175l-2.453 36.305c-2.583 25.377-24.02 41.438-48.681 41.522L0 252.9v-8.334l31.515-.072c20.365-.07 38.286-13.076 40.419-34.034L74.328 175h8.349Z" class="border"/>
      </svg>
    </div>
    <div part="border-bottom">
      <svg viewBox="0 0 3455 84" preserveAspectRatio="none">
        <defs>
          <linearGradient id="gradient">
            <stop offset="0%" class="gradient-stop-1" />
            <stop offset="100%" class="gradient-stop-2" />
          </linearGradient>
        </defs>
        <path d="M3454.17-175h66.478c-.821 16.142-.723 31.216.068 44.111 1.054 17.291 3.324 30.022 6.416 36.342 2.129 4.356 3.5 12.077 4.438 21.197.958 9.348 1.508 20.845 1.695 33.233L3532.672 0h-78.502v-175ZM3454.17 73.733c-292.38.971-747.981 1.551-1158.92 2.074-223.779.285-434.312.553-598.029.853-462.846.848-1305.35-.596-1693.19-2.763l-4.032-.252V0h3454.17v73.733Z" style="fill:url(#gradient)"/>
        <path d="M3454.17 77.9c-292.368.971-747.973 1.551-1158.91 2.074-223.778.285-434.311.553-598.027.853-462.854.848-1305.37-.596-1693.22-2.764l-4.008-.248v-8.34l4.055.255c387.836 2.168 1230.32 3.611 1693.16 2.763 163.718-.299 374.252-.568 598.032-.852 410.932-.523 866.53-1.103 1158.92-2.075V77.9Z" class="border"/>
      </svg>
    </div>
  `

  css = () => `
    :host {}

    svg {
      display: block;
      width: 100%;
      height: 100%;
    }

    svg .border {
      fill: ${this.parsedAttrs.borderColor};
    }

    svg .background-from {
      fill: ${this.parsedAttrs.bgFromColor || this.parsedAttrs.bgColor};
    }

    svg .background-to {
      fill: ${this.parsedAttrs.bgToColor || this.parsedAttrs.bgColor};
    }

    svg .gradient-stop-1 {
      stop-color: ${this.parsedAttrs.bgFromColor || this.parsedAttrs.bgColor};
    }

    svg .gradient-stop-2 {
      stop-color: ${this.parsedAttrs.bgToColor || this.parsedAttrs.bgColor};
    }

    :host-context(.hover) svg .border {
      fill: ${this.parsedAttrs.hoverBorderColor || this.parsedAttrs.borderColor};
    }

    :host-context(.hover) svg .background-from {
      fill: ${this.parsedAttrs.hoverBgFromColor || this.parsedAttrs.hoverBgColor || this.parsedAttrs.bgFromColor || this.parsedAttrs.bgColor};
    }

    :host-context(.hover) svg .background-to {
      fill: ${this.parsedAttrs.hoverBgToColor || this.parsedAttrs.hoverBgColor || this.parsedAttrs.bgToColor || this.parsedAttrs.bgColor};
    }

    :host-context(.hover) svg .gradient-stop-1 {
      stop-color: ${this.parsedAttrs.hoverBgFromColor || this.parsedAttrs.hoverBgColor || this.parsedAttrs.bgFromColor || this.parsedAttrs.bgColor};
    }

    :host-context(.hover) svg .gradient-stop-2 {
      stop-color: ${this.parsedAttrs.hoverBgToColor || this.parsedAttrs.hoverBgColor || this.parsedAttrs.bgToColor || this.parsedAttrs.bgColor};
    }
  `
}
